import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'

import { DashboardGroupBy } from '../../model/types'

type TGroupField = 'Development' | 'BusinessPriorities' | 'BusinessUnit' | 'Period' | 'Status'

export const getGroupField = (groupBy: DashboardGroupBy): TGroupField | null => {
  switch (groupBy) {
    case DashboardGroupBy.StrategicInitiative:
      return 'Development'

    case DashboardGroupBy.BusinessPriority:
      return 'BusinessPriorities'

    case DashboardGroupBy.BusinessUnit:
      return 'BusinessUnit'

    case DashboardGroupBy.Period:
      return 'Period'

    case DashboardGroupBy.Status:
      return 'Status'

    default:
      return null
  }
}

export const getGroupValue = (item: TKeyInitiative, groupBy: DashboardGroupBy) => {
  const groupField = getGroupField(groupBy)
  return groupField === 'Status'
    ? normalizeKeyInitiativeStatus(item.Status)
    : groupField
      ? item[groupField]
      : null
}
